class ScanAbortedErrorResponse {
  name: string;

  constructor() {
    this.name = "ScanAbortedErrorResponse";
  }
}

export default ScanAbortedErrorResponse;
